import { useCallback } from 'react';
import type { CardId } from '../../model/types.tsx';
import { cardRefreshRequest } from '../actions/cards/refresh/index.tsx';
import { updateDetailView } from '../actions/detail-view/index.tsx';
import { useBacklogDispatch, useBacklogSelector } from '../index.tsx';
import { isDetailViewOpenWithAnySelectedCardSelector } from '../selectors/cards/index.tsx';

export const useOnIssueVersionsUpdated = () => {
	const dispatch = useBacklogDispatch();

	const isDetailViewOpenWithAnySelectedCard = useBacklogSelector(
		isDetailViewOpenWithAnySelectedCardSelector,
	);

	return useCallback(
		(cardIds: CardId[]): void => {
			cardIds.forEach((id) => dispatch(cardRefreshRequest(id)));

			if (isDetailViewOpenWithAnySelectedCard) {
				dispatch(updateDetailView());
			}
		},
		[dispatch, isDetailViewOpenWithAnySelectedCard],
	);
};
